module.exports = __webpack_public_path__ + "statics/img/main-77778896.png";


//////////////////
// WEBPACK FOOTER
// ./web/img/xhpopulrz/download/main.png
// module id = 1208
// module chunks = 143